// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.setting-title{
    /* position: absolute; */
    /* width: 178px; */
    height: 24px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    display: flex;
    margin-top: 20px;
    margin-left: 20px;
    color: #001A11;
}
.setting-subtitle{
    display: flex;
    margin-left: 20px;
    font-family: 'Inter';
    font-weight: 400;
    font-size: 14px;
    font-style: italic;
    color: #000000;
}

[type="checkbox"]{
    opacity: 0;
}

[type="checkbox"] + label{
    position: relative;
    padding-left: 30px;
    cursor: pointer;
    display: inline-block;
    color: #666;
    line-height: 25px;
}

[type="checkbox"] + label::before {
    content: "";
    position: absolute;
    top: 10px;
    left: 0;
    width: 18px;
    height: 18px;
    outline: 2px solid #aaa;
    background:#fff ;
}

[type="checkbox"]:checked + label::before {
    content: "";
    position: absolute;
    top: 10px;
    left: 0;
    width: 6px;
    height: 12px;
    border: solid #fff;
    background:#fff ;
}
.eod-header{
/* width: 300px; */
height: 24px;

font-family: 'Inter';
font-style: normal;
font-weight: 800;
font-size: 20px;
line-height: 24px;
text-transform: capitalize;

color: #001A11;
}
/* .css-nxo287-MuiInputBase-input-MuiOutlinedInput-input {
  
    height: 10px !important;
    
} */

.css-gajhq5 {
    padding-left: 16px;
    padding-right: 16px;
    padding-bottom: 16px;
}
.timezone-select {
    margin-top: 10px;
    width: 245px !important;
}

.css-13cymwt-control:hover{
    border-color: #009966 !important
  }
  .css-t3ipsp-control{
    border-color:#009966 !important ;
    box-shadow: 0 0 0 1px #009966!important
    ;
  }

  .right-aligned-input {
    text-align: right;
  }`, "",{"version":3,"sources":["webpack://./src/components/Settings/settingStyles.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,aAAa;IACb,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,qBAAqB;IACrB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;AACA;AACA,kBAAkB;AAClB,YAAY;;AAEZ,oBAAoB;AACpB,kBAAkB;AAClB,gBAAgB;AAChB,eAAe;AACf,iBAAiB;AACjB,0BAA0B;;AAE1B,cAAc;AACd;AACA;;;;GAIG;;AAEH;IACI,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;AACxB;AACA;IACI,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI;EACF;EACA;IACE,gCAAgC;IAChC;IACA;EACF;;EAEA;IACE,iBAAiB;EACnB","sourcesContent":[".setting-title{\n    /* position: absolute; */\n    /* width: 178px; */\n    height: 24px;\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 600;\n    font-size: 20px;\n    line-height: 24px;\n    display: flex;\n    margin-top: 20px;\n    margin-left: 20px;\n    color: #001A11;\n}\n.setting-subtitle{\n    display: flex;\n    margin-left: 20px;\n    font-family: 'Inter';\n    font-weight: 400;\n    font-size: 14px;\n    font-style: italic;\n    color: #000000;\n}\n\n[type=\"checkbox\"]{\n    opacity: 0;\n}\n\n[type=\"checkbox\"] + label{\n    position: relative;\n    padding-left: 30px;\n    cursor: pointer;\n    display: inline-block;\n    color: #666;\n    line-height: 25px;\n}\n\n[type=\"checkbox\"] + label::before {\n    content: \"\";\n    position: absolute;\n    top: 10px;\n    left: 0;\n    width: 18px;\n    height: 18px;\n    outline: 2px solid #aaa;\n    background:#fff ;\n}\n\n[type=\"checkbox\"]:checked + label::before {\n    content: \"\";\n    position: absolute;\n    top: 10px;\n    left: 0;\n    width: 6px;\n    height: 12px;\n    border: solid #fff;\n    background:#fff ;\n}\n.eod-header{\n/* width: 300px; */\nheight: 24px;\n\nfont-family: 'Inter';\nfont-style: normal;\nfont-weight: 800;\nfont-size: 20px;\nline-height: 24px;\ntext-transform: capitalize;\n\ncolor: #001A11;\n}\n/* .css-nxo287-MuiInputBase-input-MuiOutlinedInput-input {\n  \n    height: 10px !important;\n    \n} */\n\n.css-gajhq5 {\n    padding-left: 16px;\n    padding-right: 16px;\n    padding-bottom: 16px;\n}\n.timezone-select {\n    margin-top: 10px;\n    width: 245px !important;\n}\n\n.css-13cymwt-control:hover{\n    border-color: #009966 !important\n  }\n  .css-t3ipsp-control{\n    border-color:#009966 !important ;\n    box-shadow: 0 0 0 1px #009966!important\n    ;\n  }\n\n  .right-aligned-input {\n    text-align: right;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
